import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getProducts(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios
    .get(`${window.apiBase}/admin/products`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllProducts(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/products`, config)
    .then(response => {
      return response.data;
    });
}

export function getProductsCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/products/count`, config)
    .then(response => {
      return response.data;
    });
}

export function addProduct(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(`${window.apiBase}/admin/products`, data, config)
    .then(response => {
      return response.data;
    });
}

export function updateProduct(user: AppUser, productId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(`${window.apiBase}/admin/products/${productId}`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deleteProduct(user: AppUser, productId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(`${window.apiBase}/admin/products/${productId}`, config)
    .then(response => {
      return response.data;
    });
}

export function getProduct(user: AppUser, productId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .get(`${window.apiBase}/admin/products/${productId}`, config)
    .then(response => {
      return response.data;
    });
}
